import { useMemo } from 'react';

/**
 * Closure Function implements countdown timer with control actions
 * @param initialValue Number
 * @param stateSetter Function callback will be called every second with current timer value
 * @returns {{startTimer: startTimer, stopTimer: stopTimer}}
 */
export const useCountdownTimer = (
  stateSetter: { (value: number): void; (arg0: number): void },
  initialValue = 0,
): { startTimer: () => void; stopTimer: () => void } =>
  useMemo((): { startTimer: () => void; stopTimer: () => void } => {
    let intervalId: ReturnType<typeof setInterval> | undefined;
    let secondsLeft: number;

    const stopTimer = (): void => {
      if (intervalId) {
        clearInterval(intervalId);
        stateSetter(0);
      }
    };

    const startTimer = (): void => {
      secondsLeft = initialValue;
      intervalId = setInterval((): void => {
        secondsLeft -= 1;
        if (secondsLeft === 0) {
          stopTimer();
        }
        stateSetter(secondsLeft);
      }, 1000);
      stateSetter(initialValue);
    };

    return {
      startTimer,
      stopTimer,
    };
  }, []);
